export const assetTypesForIssues = [
  "track",
  "Main Track 1",
  "Main Track 2",
  "CWR Jointed Track",
  "RAR Track",
  "Switch",
  "Switch LH",
  "Switch RH",
  "Yard Track",
  "Yard Track 1",
  "Yard Track 2",
  "Yard Track 3",
  "Side Track",
  "Double Diamond Crossing",
  "Diamond Crossing",
  "Spur",
  "Turnout",
  "Turnout 1",
  "Turnout 2",
  "Turnout 3",
  "Turnout 4",
  "Storage Track",
  "Storage Track 1",
  "Storage Track 2",
  "Customer Track",
  "Customer Switch LH",
  "Customer Switch RH",
  "Customer Switch",
  "Customer Yard Track",
  "Lead",
  "Lead Track",
  "Yard Switch",
  "Stub",
  "Bridge",
  "Crossing",
  "Joint",
  "Diamond",
  "Runaround Track",
  "Spur Track",
  "Stub Track",
  "RAR Siding",
  "Wye",
  "Slip Switch",
  "PATH Track",
  'Vegetation'
];

export const assetTypeTracks = [
  "track",
  "Main Track 1",
  "Main Track 2",
  "RAR Track",
  "Side Track",
  "Spur",
  "Storage Track 1",
  "Storage Track 2",
  "Storage Track",
  "Customer Track",
  "Lead",
  "Lead Track",
  "Stub",
  "Spur Track",
  "Stub Track",
  "Runaround Track",
  "RAR Siding",
  "Wye",
  "PATH Track",
];

export const yardTypeATypeTracks = [
  "RAR Track",
  "Runaround Track",
  "Yard Track",
  "Yard Track 1",
  "Yard Track 2",
  "Yard Track 3",
  "Customer Yard Track",
];

export const sidingAssetTypes = [
  "Side Track",
  "Spur",
  "Storage Track",
  "Storage Track 1",
  "Storage Track 2",
  "Stub",
  "Customer Track",
  "Lead",
  "Lead Track",
  "Spur Track",
  "Stub Track",
  "RAR Siding",
  "Wye",
  "PATH Track",
];



// WEBPACK FOOTER //
// ./src/AssetTypeConfig/Reports/DefectReportConfig.js